import dayjs from '@plvs/respawn/init/dayjs'

const DATE_FORMAT = 'MMM D'

export const formatWeekRange = (start: string, end: string): string =>
  `${dayjs(start).format(DATE_FORMAT)}-${dayjs(end).format(
    DATE_FORMAT
  )}, ${dayjs(start).format('YYYY')}`
